import React from "react";
import { InputLabel } from "../InputLabel/InputLabel.tsx";
import { MonthPicker } from "../MonthPicker/MonthPicker";
import styles from "./MonthRangePicker.module.css";
type YearMonth = React.ComponentProps<typeof MonthPicker>["value"];
type Value = { start?: YearMonth; end?: YearMonth };

/**
 * MonthRangePicker component allows the user to select a range of months.
 *
 * This works exclusively as a controlled component, meaning that the value and onSelect props are required.
 * It also means that the component does not manage its own state.
 */
export const MonthRangePicker: React.FC<{
  value: Value;
  onSelect: (value: Value) => void;
  label: string;
}> = (props) => {
  return (
    <div>
      <InputLabel>{props.label}</InputLabel>
      <div>
        <div>
          <span className={styles.prefix}>from: </span>
          <MonthPicker
            value={props.value.start || {}}
            onSelect={(value) => {
              props.onSelect({ ...props.value, start: { ...value } });
            }}
          />
        </div>
        <div>
          <span className={styles.prefix}>to: </span>
          <MonthPicker
            value={props.value.end || {}}
            onSelect={(value) => {
              props.onSelect({ ...props.value, end: { ...value } });
            }}
          />
        </div>
      </div>
    </div>
  );
};
